import React, { Component } from 'react'
import nookies from 'nookies'
import Popup from '../Popup'
import { SCREEN_SIZE } from '../../lib/Media'
import styled from 'styled-components'
import InfantFormula from '../icons/InfantFormula'
import { EventTrackingConsumer } from '../EventTrackingProvider/EventTrackingProvider'
import { GTM_ENV_VAR as GEV } from '../../lib/eventTrackerFunction'
import { disablePageScroll } from '../../lib/utils'
import { getConfigFor } from '../../utils/configService'
import { SPLIT_FEATURES } from '../../utils/constants'

const INFANT_FORMULA_DISCLAIMER_ON =
  'The content on this website is intended as general information for Singaporean residents only and should not be used as a substitute for medical care and advice from your healthcare practitioner.'

export const INFANT_FORMULA_CATEGORY = {
  ifp_cat1: 'stage-2',
  ifp_cat2: 'infant-formula--1',
  ifp_cat3: 'stage-1-1',
  ifp_cat4: 'stage-2-3',
}

export const INFANT_FORMULA_POPUP_SEEN = {
  [INFANT_FORMULA_CATEGORY.ifp_cat1]: 'ifp1',
  [INFANT_FORMULA_CATEGORY.ifp_cat2]: 'ifp2',
  [INFANT_FORMULA_CATEGORY.ifp_cat3]: 'ifp3',
  [INFANT_FORMULA_CATEGORY.ifp_cat4]: 'ifp4',
}

const StyledMainWrapper = styled.div`
  padding: 1.5rem 1rem;
  width: 95%;
  border-radius: 0.25rem;
  box-shadow: 0 0.8125rem 0.9375rem 0 rgba(0, 0, 0, 0.12);
  border: solid 0.0625rem #eaeaea;
  background-color: #fff;
  margin: 0 auto;

  ${SCREEN_SIZE.From.Desktop} {
    padding: 1.5rem;
    width: 28.75rem;
  }

  ${SCREEN_SIZE.Only.Tablet} {
    width: 60%;
  }
`

const StyledImageWrapper = styled.div`
  text-align: center;
`

const StyledInfantFormula = styled(InfantFormula)`
  width: 12.5rem;
  height: 8.75rem;
  margin-top: 0;
  margin-bottom: 1rem;
  object-fit: contain;

  ${SCREEN_SIZE.From.Tablet} {
    width: 15rem;
    height: 10.5rem;
    margin-top: 0.5rem;
    margin-bottom: 1.5rem;
  }
`

const StyledHeaderText = styled.div`
  font-size: 1.125rem;
  font-weight: bold;
  line-height: 1.5rem;
  color: #333;
  margin-bottom: 0.5rem;
`

const StyledPopupContent = styled.div`
  font-size: 1rem;
  font-weight: normal;
  line-height: 1.5rem;
  color: #333;
  position: relative;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 25rem;

  ${SCREEN_SIZE.From.Tablet} {
    max-height: 30rem;
  }
`

const StyledLink = styled.a`
  color: #1557bf;
  font-weight: bold;
`

const Spacer = styled.div`
  height: 1.5rem;
  width: 100%;
`

const StyledScrollIndicator = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  height: 1.5rem;
  width: 100%;
  margin-top: 1.5rem;
`

const StyledScrollIndicatorFixed = styled.div`
  ${SCREEN_SIZE.From.Desktop} {
    width: 26.25rem;
  }

  ${SCREEN_SIZE.Only.Tablet} {
    width: 56%;
  }

  position: fixed;
  height: 1.5rem;
  width: 86%;

  background-image: linear-gradient(
    0deg,
    #ffffff 0%,
    rgba(255, 255, 255, 0) 87%
  );
`

const StyledButtonWrapper = styled.div`
  margin: 1.5rem 0 0;
  text-align: center;
`

const StyledButton = styled.button`
  width: 15rem;
  height: 3.5rem;
  border-radius: 1.75rem;
  background-color: #1557bf;
  cursor: pointer;
  font-size: 1rem;
  font-weight: bold;
  line-height: 1.5;
  color: #fff;
  outline: none;
  border: none;
`

class InfantFormulaPopup extends Component {
  constructor(props) {
    super(props)

    this.state = {
      showPopup: true,
    }

    this.handlePopUpShown = this.handlePopUpShown.bind(this)
    this.checkIfPopupShown = this.checkIfPopupShown.bind(this)
  }

  handlePopUpShown() {
    disablePageScroll(false)
    const { track } = this.props
    const event = {
      [GEV.EVENT_CAT]: 'Ecommerce-Engagement',
      [GEV.EVENT_ACTION]: 'PopUp-Click',
      [GEV.EVENT_LABEL]: 'Label=InfantMilk-Continue',
    }
    track(event)

    this.setState({ showPopup: false })
    const options = {
      path: '/',
      maxAge: 24 * 60 * 60, // one day
    }
    nookies.set(
      {},
      INFANT_FORMULA_POPUP_SEEN[[this.props.categorySeen]],
      true,
      options
    )
  }

  checkIfPopupShown() {
    //NOTE: In future API should send a flag to show the popup & cookie logic should be removed
    const {
      [INFANT_FORMULA_POPUP_SEEN[[this.props.categorySeen]]]: popUpShown,
    } = nookies.get()

    this.setState({ showPopup: !popUpShown })
  }

  componentDidMount() {
    this.checkIfPopupShown()

    if (this.state.showPopup) {
      disablePageScroll(true)
      const { track } = this.props
      const event = {
        [GEV.EVENT_CAT]: 'Ecommerce-Engagement',
        [GEV.EVENT_ACTION]: 'PopUp',
        [GEV.EVENT_LABEL]: 'Label=InfantMilk',
      }
      track(event)
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.categorySeen !== this.props.categorySeen) {
      this.checkIfPopupShown()
    }
    disablePageScroll(this.state.showPopup)
  }

  render() {
    if (!this.state.showPopup) {
      return null
    }

    return (
      <React.Fragment>
        <Popup forceAcknowledge noMarginToAlign>
          <StyledMainWrapper data-testid="infantFormulaPopup">
            <StyledPopupContent>
              <StyledImageWrapper>
                <StyledInfantFormula />
              </StyledImageWrapper>
              <StyledHeaderText>
                Breast milk is best for babies!
              </StyledHeaderText>
              The World Health Organisation (WHO) and Health Promotion Board
              (HPB) recommends exclusive breastfeeding for the first six months
              of life. Unnecessary introduction of bottle feeding or other food
              and drinks will have a negative impact on breastfeeding.
              <br />
              <br />
              At around six months of age (but not before 4 months), infants
              should receive nutritionally adequate and age-appropriate
              complementary foods while breastfeeding continues for up to two
              years of age or beyond. If no longer breastfeeding, toddlers can
              switch to full cream milk after 12 months. This should be
              complemented by a good variety of solid foods from the four main
              food groups (fruits, vegetables, grains, meat and alternatives).
              <br />
              <br />
              Consult your doctor before deciding to use infant formula or if
              you have difficulty breastfeeding.
              <br />
              <br />
              FairPrice fully recognises breast milk’s primacy, value and
              superiority, and supports exclusive breastfeeding as recommended
              by WHO.
              <br />
              <br />
              {getConfigFor(SPLIT_FEATURES.FE_INFANT_FORMULA_DESC).isEnabled ? (
                <>
                  {INFANT_FORMULA_DISCLAIMER_ON}
                  <br />
                  <br />
                </>
              ) : null}
              For more information on the nutritional requirements of infants
              and young children, please visit &nbsp;
              <StyledLink
                href="https://www.healthhub.sg/programmes/122/early-nutrition-for-babies"
                target="_blank"
                rel="noopener noreferrer"
              >
                www.healthhub.sg/earlynutrition
              </StyledLink>
              <Spacer />
              <StyledScrollIndicator>
                <StyledScrollIndicatorFixed />
              </StyledScrollIndicator>
            </StyledPopupContent>
            <StyledButtonWrapper>
              <StyledButton onClick={this.handlePopUpShown}>
                I acknowledge
              </StyledButton>
            </StyledButtonWrapper>
          </StyledMainWrapper>
        </Popup>
      </React.Fragment>
    )
  }
}

const InfantFormulaPopupWrapper = props => (
  <EventTrackingConsumer>
    {({ track }) => <InfantFormulaPopup {...props} track={track} />}
  </EventTrackingConsumer>
)

InfantFormulaPopupWrapper.defaultProps = {}

export default InfantFormulaPopupWrapper
